module.exports = __webpack_public_path__ + "static/media/FirstAsiaConsultants.a94bb352.png";